import { useEffect, useState, type ComponentType } from 'react'

/**
 * 404 and route-error screens pull the lucide barrel. Load them after mount
 * so /login can paint "Welcome back" without that download.
 */
export function DeferredNotFound() {
  const [Page, setPage] = useState<ComponentType | null>(null)
  useEffect(() => {
    let live = true
    void import('@/components/layout/NotFoundPage').then((mod) => {
      if (live) setPage(() => mod.NotFoundPage)
    })
    return () => {
      live = false
    }
  }, [])
  return Page ? <Page /> : null
}

export function DeferredRouteError(props: {
  error: unknown
  reset?: () => void
}) {
  const [Page, setPage] = useState<ComponentType<typeof props> | null>(null)
  useEffect(() => {
    let live = true
    void import('@/components/layout/RouteErrorComponent').then((mod) => {
      if (live) setPage(() => mod.RouteErrorComponent)
    })
    return () => {
      live = false
    }
  }, [])
  return Page ? <Page {...props} /> : null
}
